// extracted by css-extract-rspack-plugin
export default {"draggable":"draggable-tuKs7A","clickable":"clickable-oLol_o"};